const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28.8px",
    viewBox: "0 0 28 28.8",
    style: {
      enableBackground: "new 0 0 28 28.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M7.4,7.3h1.8c0.3,0,0.5-0.2,0.5-0.5c0-0.9,0.2-1.6,0.5-2.2c0.3-0.6,0.8-1,1.3-1.3c0.6-0.3,1.4-0.5,2.2-0.5 h0.5c0.9,0,1.6,0.2,2.2,0.5c0.6,0.3,1,0.8,1.3,1.3c0.3,0.6,0.5,1.4,0.5,2.2c0,0.3,0.2,0.5,0.5,0.5h1.8c0.3,0,0.5-0.2,0.5-0.5 c0-1.3-0.3-2.5-0.8-3.5c-0.6-1-1.4-1.9-2.4-2.4c-1-0.6-2.2-0.8-3.5-0.8h-0.5c-1.3,0-2.5,0.3-3.5,0.8c-1,0.6-1.9,1.4-2.4,2.4 C7.2,4.3,7,5.5,7,6.8C7,7.1,7.2,7.3,7.4,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M27.5,14.2h-4.5v-2.7c2.4-0.1,4.4-2.1,4.4-4.6c0-0.3-0.2-0.5-0.5-0.5h-1.9c-0.3,0-0.5,0.2-0.5,0.5 c0,1-0.8,1.8-1.8,1.8H5.2c-1,0-1.8-0.8-1.8-1.8c0-0.3-0.2-0.5-0.5-0.5H1c-0.3,0-0.5,0.2-0.5,0.5c0,2.5,2,4.5,4.4,4.6v2.7H0.5 c-0.3,0-0.5,0.2-0.5,0.5v1.8c0,0.3,0.2,0.5,0.5,0.5h4.5v2.8c0,0.2,0,0.3,0,0.5c-2.2,1-3.7,3.3-3.7,5.7c0,0.3,0.2,0.5,0.5,0.5h1.8 c0.3,0,0.5-0.2,0.5-0.5c0-1.2,0.6-2.3,1.5-2.9c0.2,0.5,0.4,0.9,0.6,1.3c0.8,1.3,1.9,2.5,3.3,3.3c1.4,0.8,3,1.2,4.6,1.2 c1.6,0,3.2-0.4,4.6-1.2c1.3-0.8,2.5-1.9,3.3-3.3c0.2-0.4,0.5-0.9,0.6-1.3c1,0.7,1.5,1.8,1.5,2.9c0,0.3,0.2,0.5,0.5,0.5h1.8 c0.3,0,0.5-0.2,0.5-0.5c0-2.5-1.4-4.7-3.7-5.7c0-0.2,0-0.3,0-0.5v-2.8h4.5c0.3,0,0.5-0.2,0.5-0.5v-1.8C28,14.4,27.8,14.2,27.5,14.2z  M20.2,11.4v8.2c0,1.1-0.3,2.2-0.8,3.1c-0.5,0.9-1.3,1.7-2.2,2.2c-1.9,1.1-4.4,1.1-6.3,0c-0.9-0.5-1.7-1.3-2.2-2.2 c-0.6-0.9-0.8-2-0.8-3.1v-8.2H20.2z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.7863a0d89b86afd1e3a917935e0f0ea9.svg";
export { ForwardRef as ReactComponent };